import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is Soul Safe Sanctuary™?",
    answer:
      "Soul Safe Sanctuary™ is a premium, faith-based platform designed to help survivors of spiritual and narcissistic abuse heal, rebuild discernment, and pursue reform. It combines guided courses, AI-powered pastoral support, community, and certification into one structured transformation journey.",
  },
  {
    question: "Is this a replacement for therapy or counseling?",
    answer:
      "No. Soul Safe Sanctuary™ is an educational and faith-based resource. It provides shared language, biblical grounding, and structured healing pathways, but it is not a substitute for licensed therapy or clinical treatment. We encourage professional support alongside our platform.",
  },
  {
    question: "Is my information kept confidential?",
    answer:
      "Absolutely. Privacy and safety are foundational to everything we build. Your journal entries are encrypted, your AI conversations are private, and your identity in community spaces can remain anonymous. We never share your data.",
  },
  {
    question: "Who are the certifications for?",
    answer:
      "We offer two certification paths: the Survivor Certification (Soul Safe Sanctuary™ Graduate) for individuals on their healing journey, and the Leader Certification (Trained Soul Safe Sanctuary™ Leader) for pastors, elders, and ministry leaders committed to trauma-informed, accountable leadership.",
  },
  {
    question: "Do I need to be part of a church to use this?",
    answer:
      "Not at all. Soul Safe Sanctuary™ is for any believer, whether currently in a church, between churches, or healing from a church experience. The platform meets you where you are.",
  },
  {
    question: "What does the AI Pastoral Companion do?",
    answer:
      "Our AI Companion provides 100% confidential, trauma-informed conversation support grounded in Scripture. It helps you process experiences, identify manipulation patterns, and find biblical clarity, without fear of judgment or gossip.",
  },
  {
    question: "Can my church use this for training?",
    answer:
      "Yes. We offer church-wide training packages for pastors, leadership teams, volunteers, and entire congregations. Our curriculum equips churches to recognize manipulation, prevent spiritual abuse, and build cultures of accountability.",
  },
  {
    question: "Is there a free trial?",
    answer:
      "We offer accessible monthly and yearly plans. All plans include full access to courses, the AI companion, community, journaling, and certification pathways. No content is locked behind additional paywalls.",
  },
  {
    question: "What makes this different from other recovery programs?",
    answer:
      "Soul Safe Sanctuary™ is built specifically for faith-based spiritual abuse recovery. We combine trauma-informed methodology with biblical literacy, offer structured certification (not just content), and provide AI-powered confidential support, all within a safe, moderated community of believers.",
  },
  {
    question: "How do I cancel my subscription?",
    answer:
      "You can manage or cancel your subscription at any time through your account settings under the avatar menu. There are no long-term contracts or cancellation fees.",
  },
];

export function FAQ() {
  return (
    <section className="py-28 md:py-36 bg-muted/30">
      <div className="container px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto text-center mb-16"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent mb-6">
            Common Questions
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-7xl font-black text-foreground mb-6 leading-[1.05] tracking-[-0.02em]" style={{ fontFamily: "'Playfair Display', serif" }}>
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground">
            Everything you need to know about Soul Safe Sanctuary™ and your
            healing journey.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border border-border/50 bg-card px-6 rounded-sm data-[state=open]:border-accent/30 data-[state=open]:shadow-sm transition-all"
              >
                <AccordionTrigger className="text-left font-serif text-base md:text-lg font-semibold text-foreground hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
